// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/PatentsPage/PatentsPage.css
// module id = 887
// module chunks = 0